/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;


//////////////////
// WEBPACK FOOTER
// ./~/react-dom/lib/ReactDOMComponentFlags.js
// module id = 241
// module chunks = 168707334958949